(function($){

  function postslick() {
      $('section#shopify-section-template--17786144850082__featured_blog_FGaQfL .blog__posts').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      arrows: false,
      draggable: true,
      dots: true,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      cssEase: 'linear',
    });
  }

  if ($(window).width() < 767) {
    postslick();
}
		
 $(window).resize(function() {
  if ($(window).width() < 767) {
	postslick();
  }
});

   document.addEventListener('DOMContentLoaded', function () {
    const rightBtn = document.querySelector('#shopify-section-template--17786144850082__featured_collection_wWWqMz .slider-button--next');
    const leftBtn = document.querySelector('#shopify-section-template--17786144850082__featured_collection_wWWqMz .slider-button--prev');

    if (rightBtn && leftBtn) {
      rightBtn.addEventListener('click', function () {
         setTimeout(function() {
          leftBtn.removeAttribute('disabled');
        }, 1000); 
      });
    }
  });

}(jQuery));
